import React, { useState } from 'react';
import './styles.css';
import NavBar from './NavBar';

const faqData = [
  {
    question: "What is Pool Party Social Club?",
    answer: "Pool Party Social Club is a spontaneous, face-to-face social app where people in your city meet via video chat. No endless scrolling—just real connections with real people."
  },
  {
    question: "How does the Pool work?",
    answer: "The Pool is where everyone nearby appears. You can view profiles, splash users to show interest, or start a video call instantly."
  },
  {
    question: "What happens when I Splash someone?",
    answer: "Splashing changes your color in their pool and moves you up the list—like giving them a nudge without sending a message."
  },
  {
    question: "What's a Connect?",
    answer: "Connect lets you immediately video call someone. If they answer and you both vibe, you can unlock text chat to continue the conversation."
  },
  {
    question: "Can I chat with someone right away?",
    answer: "You need to connect through a video call first. If both users feel the connection, then text chat becomes available."
  },
  {
    question: "Can I remove people from my Pool?",
    answer: "Yes, you control your pool completely. Remove users you're not interested in with one tap."
  },
  {
    question: "What are Boosts?",
    answer: "Boosts increase your visibility in pools, helping you get noticed faster by more users."
  },
  {
    question: "What's a SuperSplash?",
    answer: "SuperSplash is a premium splash that jumps you even higher in someone's pool and gets extra attention."
  },
  {
    question: "Can I see who splashed me?",
    answer: "Yes, you'll always see who's splashed you. It's a great way to know who's interested in connecting."
  },
  {
    question: "Do you offer filters?",
    answer: "Yes! Use filters to find people who match your interests and preferences."
  },
  {
    question: "Is there a limit to how many people I can splash?",
    answer: "Free users have a daily splash limit. Premium users get unlimited splashes and supersplashes."
  },
  {
    question: "Is Pool Party Social Club safe?",
    answer: "Absolutely. We offer reporting, blocking, moderation, and community guidelines to keep it respectful and fun for everyone."
  },
  {
    question: "Do I need to create a detailed profile?",
    answer: "Not really—Pool Party is about real-time interaction. You can add basic details, but the focus is on face-to-face conversations."
  },
  {
    question: "Can I report inappropriate behavior?",
    answer: "Yes. Tap the '...' icon during a call or on a profile to report any abuse or violation of our community guidelines."
  },
  {
    question: "Does Pool Party work internationally?",
    answer: "Currently, it focuses on city-level connections, but more global support is coming soon."
  },
  {
    question: "Can I use Pool Party anonymously?",
    answer: "You can turn on Incognito mode to explore the pool without appearing in others' lists."
  },
  {
    question: "How do I edit my profile?",
    answer: "Tap the profile icon and go to 'Edit Profile' to change your details and preferences."
  },
  {
    question: "What makes Pool Party different from other social apps?",
    answer: "Pool Party is live, human-first, and video-based. There's no endless scrolling—just talking to real people in your area."
  },
  {
    question: "How often are people active?",
    answer: "Since the app shows live users in your city, you'll usually see dozens to hundreds of active users depending on your location."
  },
  {
    question: "Is this like Omegle?",
    answer: "It's similar in that it's video-based and instant, but Pool Party is local, curated, and focused on building genuine connections—not random strangers."
  },
  {
    question: "Is Pool Party inclusive?",
    answer: "100%! Our filters and design fully support diverse backgrounds, interests, and identities. Everyone is welcome."
  },
  {
    question: "Can I block someone?",
    answer: "Yes, blocking immediately removes them from your pool and prevents future contact."
  },
  {
    question: "Is there a desktop version?",
    answer: "Currently, Pool Party Social Club is mobile-only. A desktop experience may be added in the future."
  },
  {
    question: "How do I download the app?",
    answer: "You can download it on Google Play using the link on our Download page. iOS coming soon!"
  },
  {
    question: "Does it cost money?",
    answer: "The core app is free! Some features like Boosts and SuperSplashes are premium."
  },
  {
    question: "Can I undo a splash?",
    answer: "Not yet. We're considering adding this in future versions."
  },
  {
    question: "What's the age requirement?",
    answer: "You must be at least 18 years old to use Pool Party Social Club."
  },
  {
    question: "How do I delete my account?",
    answer: "Go to your profile settings, scroll down, and select 'Delete Account'."
  },
  {
    question: "Where can I give feedback?",
    answer: "We love hearing from users! Use the Contact page or email us directly."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {NavBar()}
      <div className="faq-wrapper">
        <h1 className="faq-title">Frequently Asked Questions</h1>

        <p className="faq-intro">
          Pool Party Social Club is a spontaneous <strong>social video app</strong> that helps you <strong>meet real people nearby</strong> through live face-to-face conversations. Unlike traditional <strong>social apps</strong>, we focus on <strong>genuine, in-the-moment connections</strong> with no endless messaging. Whether you're new to a city, looking to expand your social circle, or just want a more human experience, Pool Party lets you <strong>connect instantly with people in your area</strong>.
        </p>

        <div className="faq-list">
          {faqData.map((item, index) => (
            <div
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
              key={index}
              onClick={() => toggleQuestion(index)}
            >
              <div className="faq-question">
                <span>{item.question}</span>
                <span className={`faq-toggle ${openIndex === index ? 'rotated' : ''}`}>▼</span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FAQ;
